<div class="otto-olsen-claim-receipt text-center my-5">
  <h3 class="mb-4">Din reklamasjon er mottatt</h3>
  <p>Otto Olsen har mottatt din retursøknad for ordrenummer {{ orderId }}. Det vil også bli sendt en kvittering til epostadressen din.</p>
  <p>Du vil normalt sett få svar på søknaden i løpet av en virkedag.</p>
  <p class="mb-4">Hilsen oss i Otto Olsen</p>
  <button class="btn btn-outline-primary" (click)="backToOrders()">Tilbake til ordreoversikt</button>
</div>
